module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/btn_google-6c6c98e6462cadef91690b62a7d7aa2a.png";